import { Timeline, Text } from "@mantine/core"
import { match } from "ts-pattern"
import { PrincipalName } from "../../../../../blocks/persons-and-users/User"
import dayjs from "dayjs"
import {
  AbsenceRequestEvent,
  AbsenceRequestEventHeader,
  PrincipalId,
} from "../../../../../@client/Absents"
import { EventEnvelope } from "../../../../../@client/TinyEventStore"
import { AbsenceRequestViewmodel } from "../../../../../@client/Theasoft_Absences"

function renderTimelineItem(
  title: string,
  principalId: PrincipalId,
  timestamp: string,
  key: string
) {
  return (
    <Timeline.Item title={title} key={key}>
      <Text c="dimmed" size="sm">
        Von <PrincipalName id={principalId} />
      </Text>
      <Text c="dimmed" size="xs" mt={4}>
        {dayjs(timestamp).format("L LT")}
      </Text>
    </Timeline.Item>
  )
}

function RenderAsTimelineItem({
  data,
}: {
  data: EventEnvelope<number, AbsenceRequestEvent, AbsenceRequestEventHeader>
}) {
  return match(data.payload)
    .with({ Case: "ApprovalWorkflowCreated" }, () =>
      renderTimelineItem(
        "Angefragt",
        data.header.principalId,
        data.timestamp,
        data.eventId
      )
    )
    .with({ Case: "ApprovalStepReviewed" }, (x) =>
      x.Fields.item2.result.Case === "Approved"
        ? renderTimelineItem(
            "Genehmigt",
            data.header.principalId,
            data.timestamp,
            data.eventId
          )
        : x.Fields.item2.result.Case === "Rejected"
          ? renderTimelineItem(
              "Abgelehnt",
              data.header.principalId,
              data.timestamp,
              data.eventId
            )
          : null
    )
    .with({ Case: "FinallyReviewed" }, (x) =>
      x.Fields.result.Case === "Approved"
        ? renderTimelineItem(
            "Final genehmigt",
            data.header.principalId,
            data.timestamp,
            data.eventId
          )
        : x.Fields.result.Case === "Rejected"
          ? renderTimelineItem(
              "Final abgelehnt",
              data.header.principalId,
              data.timestamp,
              data.eventId
            )
          : null
    )
    .with({ Case: "FinalDecisionChanged" }, (x) =>
      x.Fields.result.Case === "Approved"
        ? renderTimelineItem(
            "Finale Entscheind geandert: Genehmigt",
            data.header.principalId,
            data.timestamp,
            data.eventId
          )
        : x.Fields.result.Case === "Rejected"
          ? renderTimelineItem(
              "Finale Entscheidung geaendert: Abgelehnt",
              data.header.principalId,
              data.timestamp,
              data.eventId
            )
          : null
    )
    .otherwise(() => null)
}

export function ReviewHistory({ data }: { data: AbsenceRequestViewmodel }) {
  return (
    <div>
      <Timeline>
        {data.events.map((v) => (
          <RenderAsTimelineItem data={v} />
        ))}
      </Timeline>
    </div>
  )
}
